module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"404":"404 ошибка.","pageNotFound":"Нет такой страницы","toMainPage":"На главную страницу","companyInfo":"Информация о компании","contactUs":"Написать нам письмо"}}')
  delete Component.options._Ctor
}
